'use client'

import ScriptRequestFormProvider, {
  ScriptRequestFormProps,
} from '@/features/prescriptions/request/ScriptRequestFormProvider'
import ScriptRequestForm, {
  CategoryDetails,
} from '@/features/prescriptions/request/ScriptRequestForm'

type Props = {
  providerProps: ScriptRequestFormProps
  categoryDetails?: CategoryDetails
}

export default function ScriptRequestFormContainer({
  providerProps,
  categoryDetails,
}: Props) {
  return (
    <ScriptRequestFormProvider {...providerProps}>
      <ScriptRequestForm
        session={providerProps.session}
        profile={providerProps.initialProfile}
        profileStatus={providerProps.profileStatus}
        categoryDetails={categoryDetails}
      />
    </ScriptRequestFormProvider>
  )
}
